import { analyticsUtils } from 'utils/analytics-utils';

type TPageViewParams = {
  pagePath: string;
  userId?: number | null;
  loyaltyCardNumber?: string | null;
  regionId?: string | null;
  geo?: string | null;
  clientType?: string | null;
  userAuth?: string | null;
};

/**
 * Событие должно срабатывать при попадании во viewport.
 *
 */

export const gaPageView = ({
  loyaltyCardNumber,
  pagePath,
  userId,
  regionId,
  geo,
  clientType,
  userAuth,
}: TPageViewParams) =>
  analyticsUtils.sendEvent('GA:pageview', {
    pageType: 'Configurator', // тип страницы
    pagePath, // полный url страницы, не должен пересекаться с url других страниц
    lkType: 'Клиент ЛК',
    userId: userId ? String(userId) : null, // customerId из сириуса
    userAuth,
    clientType, // тип пользователя: Профи, Вендор, Авторизованный, Держатель СК, Неавторизованный
    loyaltyCardNumber, // номер карты сервисной карты (если нет, не передается)
    platform: 'react', // платформа страницы
    cityId: regionId, // id города
    geoLocation: geo, // координаты гео через запятую
    businessModel: 'LM', // бизнес-модель LM или Market
  });
